import { LocationInput, EditLocationQuery } from '@kinetic-ui/data-layer';
import { LocationFormValues } from '../types';
import { Override, RecursivePartial } from 'types/util';

export type EditLocation = Override<NonNullable<EditLocationQuery['location']>, { id?: string }>;

export const LocationFormToInput = (
  formValues: RecursivePartial<LocationFormValues>
): LocationInput => {
  const validValues = formValues as LocationFormValues;

  const input: LocationInput = {
    id: validValues.id,
    details: {
      name: validValues.name,
      description: validValues.description,
    },
    locationType: validValues.locationType,
    geometry: validValues.geometry,
    crosswalks: validValues.crosswalks ?? [],
    lanes: validValues.lanes ?? [],
    maneuvers: validValues.maneuvers ?? [],
    color: validValues.color,
    opacity: validValues.opacity,
  };

  return input;
};
